module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/babel-runtime@6.26.0/~/babel-runtime/core-js/promise.js
// module id = 140
// module chunks = 1